import { IFormDocument, IField } from 'app/services/api5-service/api.interface';

import { getCombinedControls } from './combined';
import {
  getTypeControlsForButton,
  getTypeControlsForCaptcha,
  getTypeControlsForDateTime,
  getTypeControlsForFrame,
  getTypeControlsForInput,
  getTypeControlsForLink,
  getTypeControlsForList,
  getTypeControlsForListFilter,
  getTypeControlsForReflect,
  getTypeControlsForSelect,
  getTypeControlsForSlider,
  getTypeControlsForTextarea,
  getTypeControlsForTextData,
  getTypeControlsForTicket,
  getTypeControlsForTree,
  TypedControl,
} from './controls';
import { TypedPage } from './get-typed-page';

export interface TypedField {
  readonly controls: TypedControl[];
  /** Original metadata */
  readonly field: IField;
  /** Field page parent */
  parent?: TypedPage;
}

/**
 * Map field control metadata to typed object with value from doc state
 *
 * @param field - field metadata
 * @param doc - doc
 */
export function getTypedField(field: IField, doc: IFormDocument): TypedField {
  const reflectControl = getTypeControlsForReflect(field);
  const captchaControl = getTypeControlsForCaptcha(field);
  const inputControls = getTypeControlsForInput(field, doc);
  const selectControls = getTypeControlsForSelect(field, doc);
  const datetimeControls = getTypeControlsForDateTime(field, doc);
  const textareaControls = getTypeControlsForTextarea(field, doc);
  const linkControls = getTypeControlsForLink(field);
  const listFilterControls = getTypeControlsForListFilter(field, doc);
  const listControl = getTypeControlsForList(field, doc);
  const textdataControl = getTypeControlsForTextData(field);
  const frameControl = getTypeControlsForFrame(field, doc);
  const sliderControl = getTypeControlsForSlider(field, doc);
  const treeControl = getTypeControlsForTree(field, doc);
  const ticketControl = getTypeControlsForTicket(field, doc);
  const buttonControl = getTypeControlsForButton(field);

  const uncombinedControls: TypedControl[] = [
    ...captchaControl,
    ...inputControls,
    ...selectControls,
    ...datetimeControls,
    ...textareaControls,
    ...listFilterControls,
    ...listControl,
    // @WARN textdataControls must go before linkControls to show them in right order
    ...textdataControl,
    ...linkControls,
    ...frameControl,
    ...sliderControl,
    ...treeControl,
    ...ticketControl,
    ...buttonControl,
    ...reflectControl,
  ];

  const controls = getCombinedControls(uncombinedControls, doc);

  const typedField: TypedField = {
    field,
    controls,
  };

  controls.forEach(control => {
    control.parent = typedField;
  });

  return typedField;
}
